import { useNavigate } from 'react-router-dom';
import Icon from "@/components/units/Icon";
import { useSelector } from 'react-redux';
import { getNavigationUrl, navigateToTab, navigateToURL } from "@/utility/navigate"
import { useEffect, useRef, useState } from 'react';
import "@/index.css"

import { getLLTtoken } from "@/utility/getLLT";

const shouldShowMoreOptions =
    import.meta.env.VITE_PRODUCT_ENABLED_FNO == "true" ||
    import.meta.env.VITE_PRODUCT_ENABLED_IPO == "true" ||
    import.meta.env.VITE_PRODUCT_ENABLED_ADV == "true" ||
    import.meta.env.VITE_PRODUCT_ENABLED_INSURANCE == "true";


const getAdvisoryURL = (uniqueCientCode) => {
    const advisoryBaseUrl = import.meta.env.VITE_ADVISORY_BASE;
    return `${advisoryBaseUrl}?entity_id=${uniqueCientCode}&token=${getLLTtoken() || 'null'}`;
}

const NavBarItem = ({navItem,isMobile,navigateMethod,isActive}) => {

    return (
        <div
            onClick={()=>navigateMethod(navItem)}
            className={`tw-flex tw-items-center tw-justify-center tw-gap-2 tw-cursor-pointer ${!isMobile ? "tw-w-28 tw-h-10" : "tw-flex-col tw-py-2"} ${isMobile ? isActive ? "tw-text-[#001316]" : "tw-text-[#94B8BE]" : isActive ? "tw-text-customCyan" : "tw-text-white"}`}
            style={{
                backgroundImage: isActive && !isMobile
                    ? "linear-gradient(180deg, rgba(0, 19, 22, 0) -17.5%, rgba(83, 186, 186, 0.12) 51.7%, rgba(117, 255, 255, 0.01) 90.05%, #75FFFF 118.75%)"
                    : ""
            }}
        >
            <div className={`${isMobile ? "tw-py-[6px] tw-px-[13px]":"tw-p-0"} tw-rounded-full ${isActive && isMobile ?"tw-bg-[#003E48]":'tw-bg-transparent'}`}>
            {
                navItem.icon &&
                <div className={`tw-w-0 tw-opacity-0 tw-overflow-hidden tw-transition-all tw-duration-300 ${isActive ? " tw-w-[18px] tw-opacity-100" : ""}`}>
                    <Icon iconName={navItem.icon} wrapperStyle={`tw-flex tw-items-center tw-justify-center ${isMobile ? isActive ? "tw-text-white" :"tw-text-black" : isActive ? "tw-text-customCyan" : "tw-text-white"}`} svgProp={{ width: isMobile ? 24 : 16, height: isMobile ? 24 : 16 }} />
                </div>
            }
            </div>
            <div
                className={"tw-flex tw-text-center tw-text-xs xs:tw-text-sm"}
                to={navItem.path}
            >
                {navItem.title}
            </div>
        </div>
    )
}
    
const NavBar = ({userData,activeMenuTitle}) => {
    // TODO: Remove usage of isMobile
    const isMobile = useSelector((state) => state.global.device.below.sm);

    const [showMoreOptions, setShowMoreOptions] = useState(false);
   
    const navigate = useNavigate()

    const navigationLinkList = [
        {
            title: 'Home',
            icon: 'homeicon',
            link: '/',
        },
        {
            isDisabled: import.meta.env.VITE_PRODUCT_ENABLED_BANK != "true",
            title: 'Bank',
            icon: 'bank',
            link: '/digital-bank',
        },
        {
            title: 'Stocks',
            icon: 'stock',
            link: getNavigationUrl("/stocks", userData?.isDematUser)
        },
        {
            isDisabled: import.meta.env.VITE_PRODUCT_ENABLED_MF != "true",
            title: 'Mutual Fund',
            icon: 'mutual-fund',
            link: getNavigationUrl("/mutual-funds", userData?.isDematUser)
        },
        {
            isDisabled: !shouldShowMoreOptions,
            title: <div className='tw-gap-2 tw-flex tw-justify-center tw-items-center'>
            More <div className={`tw-transition-transform tw-duration-300 ${showMoreOptions ? " tw-rotate-180" : ""}`}><Icon iconName='down-arrow'/></div>
            </div>,
            action: "toggleMoreOptions",
        }
    ]

    const moreOptions = [
        {
            icon: 'fno',
            title: "F&O",
            description: "Activate Future & Option segment to get started",
            link: getNavigationUrl("/stocks", userData?.isDematUser),
            isDisabled: import.meta.env.VITE_PRODUCT_ENABLED_FNO !== "true"
        },
        {
            icon: 'ipo',
            title: "IPO",
            description: "Latest IPOs at your fingertips",
            isDisabled: import.meta.env.VITE_PRODUCT_ENABLED_IPO !== "true"
        },
        {
            icon: 'advisory',
            title: "Advisory",
            description: "Personalised investment guidance",
            isDisabled: import.meta.env.VITE_PRODUCT_ENABLED_ADV !== "true",
            link: getNavigationUrl(getAdvisoryURL(userData?.uniqueCientCode), userData?.isDematUser),
            // action: "navigateAdvisory",
            openInNewTab: true,
        },
        {
            icon: 'insurance',
            title: 'Insurance',
            badge: 'NEW', 
            description: "Secure your future with our new insurance product",
            isDisabled: import.meta.env.VITE_PRODUCT_ENABLED_INSURANCE !== "true"
        },
        {
            icon: 'algoxpert',
            title: 'AlgoXpert',
            description: "Create, test and execute customized strategies",
            isDisabled: import.meta.env.VITE_PRODUCT_ENABLED_ALGOXPERT !== "true",
            link: getNavigationUrl("/algoXpert/", userData?.isDematUser),
            openInNewTab: true,
        }
    ]

    const [navLinks, setNavLinks] = useState([]);

    const dropdownRef = useRef()

    const navigation = (navItem) => {
        const navigationMethod = navItem.openInNewTab ? navigateToTab : navigateToURL
        if(navItem.link){
            navigationMethod(navItem.link)
        } else if (navItem.path){
            navigate(navItem.path)
        } else if(navItem.action) {
            switch (navItem.action) {
                case "toggleMoreOptions":
                    setShowMoreOptions(prev => !prev)
                    break;
                // case "navigateAdvisory":
                //     navigationMethod(getNavigationUrl(getAdvisoryURL(userData?.uniqueCientCode), userData?.isDematUser))
                //     break;
            }
        }
    }

    useEffect(() => {
        const handleHideDropdown = (e) => {
            if(dropdownRef.current && !dropdownRef.current.contains(e.target))
                setShowMoreOptions(false)
        }

        window.addEventListener("click", handleHideDropdown)

        return () => {
            window.removeEventListener("click",handleHideDropdown)
        }
    },[showMoreOptions])

    useEffect(()=>{
        let isBankCustomer = userData?.ssfbCustomerId
        if(userData){
            setNavLinks(() => navigationLinkList.filter(link => !link.isDisabled && (link.title != "Bank" || (link.title === "Bank" && isBankCustomer))))
        }

    },[userData,showMoreOptions])

    return (
        <div className={`tw-absolute tw-left-[50vw] tw-translate-x-[-50%] tw-z-40`} ref={dropdownRef}>
            <nav
                className={`tw-flex tw-top-0 tw-rounded-bl-[10px] tw-overflow-hidden tw-rounded-br-[10px] tw-bg-[#0D2B2D]`} 
                style={{
                    boxShadow: isMobile ? "0px -1px 0px 0px #C3E8E8" : ""
                }}
            >
                {
                    navLinks.map((navItem) => <NavBarItem key={navItem.title} isMobile={isMobile} navigateMethod={navigation} navItem={navItem} isActive={navItem.title === activeMenuTitle} />)
                }
            </nav>
            {
                showMoreOptions &&
                <div className='tw-z-50 tw-mt-2 tw-bg-[#0D2B2D] tw-flex tw-flex-col tw-p-3 tw-rounded-b-[20px] tw-border-b-2 tw-border-[#75FFFF]'>
                    {
                        moreOptions.filter(option =>!option.isDisabled).map(option => {
                            return (
                                <div
                                    key={option.title}
                                    className='tw-flex tw-items-center tw-text-white tw-gap-4 tw-p-4 tw-cursor-pointer hover:tw-bg-[#FFFFFF11] tw-rounded-[8px]' onClick={() => navigation(option)}>
                                    <div className='tw-w-[46px] tw-h-[46px] tw-flex tw-items-center tw-justify-center tw-bg-[#75FFFF14] tw-rounded-[10px]'>
                                        <Icon wrapperStyle='tw-w-6 tw-h-6' iconName={option.icon}/>
                                    </div>
                                    <div className='tw-flex-1'>
                                        <div className='tw-text-[16px] tw-flex tw-gap-2 tw-items-center'>{option.title} { option.badge && <div className='tw-text-[10px] tw-text-[#005765] tw-h-5 tw-px-3 tw-rounded-full tw-flex tw-justify-center tw-items-center tw-bg-[#75FFFF]'>{option.badge.title || option.badge}</div>}</div>
                                        <div className='tw-text-[14px]'>{option.description}</div>
                                    </div>
                                </div>
                            )
                        }
                    )}
                </div>
            }
        </div>
    );
};

export default NavBar;
